import { createFileRoute } from '@tanstack/react-router';
import { ActionDevRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId')({
  component: ActionDevRoute,
});
